import { AfterViewChecked, AfterViewInit, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { MenuWidget } from "../../../models/menu-widget.model";
import { DataService } from 'src/app/services/data.service';
import { MenuService } from 'src/app/services/menu-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'tree-menu',
  templateUrl: './tree-menu.component.html',
  styleUrls: ['./tree-menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TreeMenuComponent implements OnInit {
  static compName = 'TreeMenu';

  @Input() data!: MenuWidget[];
  @Input() props!: any;
  @Input() endpoint!: string;
  @Input() level: number = 0;

  activeLink: string = '';
  isLoading: boolean = true;

  constructor(private dataService: DataService, private router: Router, private menuService: MenuService) { }

  ngOnInit(): void {

    if (this.endpoint) {
      this.dataService.getData(this.endpoint).subscribe(data => {
        this.data = this.mapMenuData(data);
        this.menuService.emitMenuItems(data);
        this.setLevels(this.data, 0);
        this.activeLink = this.router.url !== ('/' + environment.adminPath) ? this.router.url : '';
        this.restoreActiveState();
        this.isLoading = false;
      });
    } else {
      this.menuService.emitMenuItem(null);
      this.isLoading = false;
    }
  }

  setLevels(items: any[], level: number) {
    items.forEach(item => {
      item.level = level;
      if (item.below && item.below.length > 0)
        this.setLevels(item.below, level + 1);
    });
  }

  toggleMenu(item: MenuWidget, event: MouseEvent): void {
    item.opened = !item.opened;
    this.closeOtherMenus(item);
    event.stopPropagation();
  }



  navigate(item: MenuWidget, event: MouseEvent): void {

    if (item.link?.startsWith('http')) {
      // window.open(item.link, '_blank'); // nuova scheda
      window.location.assign(item.link);
      return;
    }

    if (event.target instanceof HTMLElement && event.target.classList.contains('trasparenza-arrow')) {
      this.toggleMenu(item, event);
      return;
    }

    if (item.link === ('/' + environment.adminPath)) {
      this.toggleMenu(item, event);
      return;
    }

    this.activeLink = item.link;

    this.menuService.emitMenuItem(item);
    this.router.navigateByUrl(item.link).then(() => this.restoreActiveState());
  }

  private mapMenuData(data: any[]): MenuWidget[] {
    return data.map(item => ({
      key: item.id,
      permission: item.idObblighi,
      entityType: item.entityType,
      title: item.title,
      link: this.getFullLink(item),
      below: item.below.length ? this.mapMenuData(item.below) : [],
      visible: item.visible ?? true,
      selected: false,
      opened: false
    }));
  }

  private getFullLink(item: { link: string }): string {
    if (item.link?.startsWith('http')) {
      return item.link;
    }
    return this.props.prefisso ? `/${this.props.prefisso}${item.link}` : item.link;
  }

  private restoreActiveState(): void {
    this.data.forEach(item => this.markActiveAndOpenParents(item, this.activeLink));
  }

  private closeOtherMenus(selectedItem: MenuWidget): void {
    this.data.forEach(item => {
      if (item !== selectedItem)
        item.opened = false;
      item.below.forEach(subItem => subItem.opened = false);
    });
  }

  private markActiveAndOpenParents(item: MenuWidget, activeLink: string): boolean {
    const cleanLink = activeLink.split('?')[0].split('#')[0];
    if (item.link === cleanLink) {
      this.data.forEach(item => item.selected = false);
      item.selected = true;
      this.menuService.emitMenuItem(item);
      item.opened = true;
      return true
    }


    const foundActiveChild = item.below.filter((subItem): subItem is MenuWidget => subItem != null).some(subItem => this.markActiveAndOpenParents(subItem, activeLink));
    if (foundActiveChild) {
      item.opened = true;
      return true
    }

    /// in caso di /edit
    const preEditOrCreateUrl = this.router.url?.split(/\/(edit|create)/)[0];
    if (item.link === preEditOrCreateUrl && preEditOrCreateUrl !== ('/' + environment.adminPath)) {
      this.menuService.emitMenuItem(item);
      item.selected = true;
      item.opened = true;
      return true
    }
    return false;
  }

}
